
module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<path d=\"M13 0l1 1v7l-1 1H7l-2 3H4V9H2L1 8V1l1-1h11z\"></path>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
